import React from "react";

import Link from "next/link";
import { ArrowRight } from "lucide-react";

type HeadingProps = {
  heading: string;
  subHeading?: string;
  classNames?: string;
  link?: string;
  onClick?: () => void;
};

const SectionHeading: React.FC<HeadingProps> = ({
  heading,
  subHeading,
  classNames,
  link,
  onClick,
}) => {
  return (
    <div className={classNames ? `${classNames}` : ""}>
      <div className="flex flex-col items-center gap-2 lg:flex-row lg:justify-between lg:items-end lg:mb-4">
        {/* Title Section */}
        <div className="shrink-0 lg:mr-4">
          <h2 className="whitespace-nowrap text-center font-lora tracking-normal text-[#005F52] text-2xl font-semibold leading-none lg:text-left lg:text-4xl lg:leading-10">
            {heading}
          </h2>
          <p className="text-center font-lora text-[#3E4946] mt-1 mb-4 text-sm font-semibold leading-5 hidden lg:text-left lg:mt-2 lg:mb-0 lg:text-base lg:font-normal lg:leading-6 lg:block">
            {subHeading}
          </p>
        </div>

        {link && (
          <Link
            href={link}
            className="text-v2-secondary font-bold uppercase tracking-widest flex items-center gap-2 group max-lg:hidden font-lora"
            onClick={onClick}
          >
            View All
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Link>
        )}
      </div>
    </div>
  );
};

export default SectionHeading;
